import React, { useState, useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import cyberImg from '../../../Assets/Images/Cybersecurity.svg'
import Cloude from '../../../Assets/Images/Cloude.svg'
import strategic from '../../../Assets/Images/Strategic.svg'
import aiService from '../../../Assets/Images/AiService.svg'
import artificial from '../../../Assets/Images/artificial.png';
import cyberIcon from '../../../Assets/Images/cyber-security.png';
import server from '../../../Assets/Images/server.png';
import strategicIcon from '../../../Assets/Images/strategic.png';
import { useNavigate } from 'react-router-dom';

const solution = [
    {
    img: strategic,
    title: "Software Development",
    desc: "Software Development involves designing, building, testing, and maintaining custom applications tailored to specific business needs. It focuses on creating scalable, secure, and high-performance solutions.",
    icon: server,
    path :"/services/software-development/custom-enterprise-software",
    color: "from-amber-500 to-orange-500"
  },
  {
    img: cyberImg,
    title: "Engineering Digital Solutions",
    desc: "Engineering Digital Solutions involves designing and developing innovative, technology-driven systems that solve complex business challenges.",
    icon: artificial,
     path :"/services/engineering-digital-solutions/lims",
    color: "from-blue-500 to-purple-500"
  },
  {
    img: Cloude,
    title: "Cloud & Infrastructure (VDI Focus)",
    desc: "Cloud & Infrastructure (VDI Focus) centers on delivering secure, scalable virtual desktop environments that enable remote access to applications and data from any location. It ensures centralized management, enhanced data security",
    icon: cyberIcon,
     path :"/services/cloud-infrastructure/virtual-desktop-infrastructure-vdi",
    color: "from-emerald-500 to-cyan-500"
  },
  {
    img: aiService,
    title: "Data & AI Solutions",
    desc: "Data & AI Solutions focus on transforming raw data into actionable insights using advanced analytics, machine learning, and intelligent automation. These solutions help organizations optimize decision-making, uncover patterns, improve operational efficiency.",
    icon: strategicIcon,
     path :"/services/data-ai-solutions/predictive-analytics",
    color: "from-rose-500 to-pink-500"
  }
];

export default function Expertise() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeCard, setActiveCard] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
    
    // Handle scroll for vertical card switching
    const handleScroll = () => {
      const cards = document.querySelectorAll('.card-container');
      if (!cards.length) return;

      // Find which card is currently in view
      let currentCard = 0;
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Card is considered "active" when it's in the middle of the viewport
        if (rect.top < windowHeight / 2 && rect.bottom > windowHeight / 2) {
          currentCard = index;
        }
      });
      
      setActiveCard(currentCard);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 py-20 px-4 sm:px-6 relative overflow-hidden">
      {/* Grid Pattern Background */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:64px_64px]"></div>

      {/* Decorative circle */}
      <div className="absolute top-10 right-10 w-64 h-64 md:w-96 md:h-96 border border-slate-700/30 rounded-full"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Header Section */}
        <div className="text-center space-y-8 mb-16">
          {/* Badge */}
          <div 
            className={`inline-flex items-center gap-3 px-6 py-3 md:px-8 md:py-4 bg-blue-900/40 backdrop-blur-sm rounded-full border border-blue-500/30 transition-all duration-1000 ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
            }`}
          >
            <div className="w-2 h-2 bg-blue-400 rounded-sm"></div>
            <span className="text-blue-100 font-medium text-sm md:text-base">Our Expertise</span>
            <div className="w-2 h-2 bg-blue-400 rounded-sm"></div>
          </div>

          {/* Heading */}
          <div className="space-y-4">
            <h2 
              className={`text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight transition-all duration-1000 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <span className="italic">Smart Solutions</span> for Modern Businesses
            </h2>
          </div>

          {/* Description */}
          <p 
            className={`text-slate-300  md:text-lg max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-400 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            We provide end-to-end IT services designed to optimize operations, strengthen security, and accelerate digital transformation.
          </p>
        </div>
        {/* Cards Container */}
        <div className="relative ">
          {solution.map((service, index) => (
            <div 
              key={index}
              className="card-container sticky  flex items-center justify-center"
              style={{
                top: '2rem',
                zIndex: solution.length - index, // Higher index = higher z-index
              }}
            >
              {/* Card */}
              <div 
                className={`w-full max-w-6xl bg-gradient-to-br from-white to-slate-50 rounded-[3rem] p-8 md:p-12 shadow-2xl transition-all duration-700 ${
                  activeCard === index 
                    ? 'opacity-100 scale-100 translate-y-0' 
                    : activeCard > index
                    ? 'opacity-0 scale-90 -translate-y-20'
                    : 'opacity-0 scale-90 translate-y-20'
                }`}
              >
                {/* Decorative border */}
                <div className={`absolute inset-0 rounded-[3rem] bg-gradient-to-r ${service.color} opacity-5`}></div>
                
                <div className="grid lg:grid-cols-2 gap-6 md:gap-12 items-center relative z-10">
                  {/* Image Section */}
                <div className="relative">
               <img src={service.img} alt={service.title} />

                <div className="hidden md:flex absolute top-8 right-20  lg:-top-8 lg:right-0">
                   <div className="w-32 h-32 bg-gray-300  rounded-full flex items-center justify-center border-4 border-slate-800 shadow-xl">
                     <img src={service.icon} alt=""  className='size-12 '/>
                    
                   </div>
                 </div>
               </div>

                  {/* Content Section */}
                  <div className="space-y-4 md:space-y-6">
                    <div className="space-y-2 md:space-y-4">
                      <h3 className="text-xl md:text-3xl font-bold text-slate-900">
                        {service.title}
                        <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          width="80" 
                          height="26" 
                          viewBox="0 0 80 26" 
                          fill="none" 
                          className="mt-2 mb-1"
                        >
                          <path 
                            fillRule="evenodd" 
                            clipRule="evenodd" 
                            d="M15.873 2.7627C15.8731 4.45899 16.0664 6.13367 16.8838 7.50489C18.6463 10.461 21.4986 11.7483 25.6084 12.2842C27.1497 12.4851 28.8527 12.5787 30.7236 12.6172C32.6766 12.5771 34.8027 12.5965 37.0986 12.6172C38.5257 12.6044 40.0247 12.5918 41.5967 12.5918H80V13.4082H41.5967C40.0247 13.4082 38.5257 13.3956 37.0986 13.3828C34.8027 13.4035 32.6766 13.4219 30.7236 13.3818C28.8527 13.4203 27.1497 13.5149 25.6084 13.7158C21.4986 14.2517 18.6463 15.539 16.8838 18.4951C16.0664 19.8663 15.8731 21.541 15.873 23.2373V26C15.873 26 15.4996 26 15.127 26V23.2373C15.1269 21.541 14.9336 19.8663 14.1162 18.4951C12.3537 15.539 9.5014 14.2517 5.3916 13.7158C3.85001 13.5148 2.1467 13.4203 0.275391 13.3818C0.183999 13.3837 0.0921491 13.3831 0 13.3848V12.6133C0.0921563 12.6149 0.183992 12.6153 0.275391 12.6172C2.14669 12.5787 3.85001 12.4852 5.3916 12.2842C9.5014 11.7483 12.3537 10.461 14.1162 7.50489C14.9336 6.13367 15.1269 4.45899 15.127 2.7627V2.64338e-06C15.4996 -3.30422e-06 15.873 2.64338e-06 15.873 2.64338e-06V2.7627ZM15.5 6.10157C15.3308 6.72831 15.0906 7.33619 14.752 7.9043C12.8675 11.0647 9.85258 12.4249 5.80078 13C9.85258 13.5751 12.8675 14.9353 14.752 18.0957C15.0905 18.6636 15.3309 19.271 15.5 19.8975C15.6691 19.271 15.9095 18.6636 16.248 18.0957C18.1324 14.9355 21.1468 13.5751 25.1982 13C21.1468 12.4249 18.1324 11.0645 16.248 7.9043C15.9094 7.33619 15.6692 6.72831 15.5 6.10157Z" 
                            fill="currentColor"
                          ></path>
                        </svg>
                      </h3>
                    </div>

                    <p className="text-slate-600 text-sm md:text-base leading-relaxed">
                      {service.desc}
                    </p>

                    <div className="pt-4">
                      <button 
                      onClick={()=>{
                        navigate(`${service.path}`);
                        window.scrollTo({
                          top:0,
                          behavior :"smooth"
                        })
                      }}
                      className="group px-6 py-3 md:px-8 md:py-4 bg-slate-900 text-white rounded-xl font-medium hover:bg-slate-800 transition-all duration-300 hover:scale-105 hover:shadow-2xl flex items-center gap-3">
                        Explore Now
                        <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                      </button>
                    </div>
                  </div>
                </div>
                
                {/* Card Number */}
                <div className="absolute top-6 right-6 text-5xl md:text-6xl font-black text-slate-900/10">
                  0{index + 1}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


// import React, { useState, useEffect } from 'react';
// import { ArrowUpRight, Shield } from 'lucide-react';
// import cyberImg from '../../../Assets/Images/Cybersecurity.svg'
// import Cloude from '../../../Assets/Images/Cloude.svg'
// import strategic from '../../../Assets/Images/Strategic.svg'
// import aiService from '../../../Assets/Images/AiService.svg'
// import artificial from '../../../Assets/Images/artificial.png';
// import cyberIcon from '../../../Assets/Images/cyber-security.png';
// import server from '../../../Assets/Images/server.png';
// import strategicIcon from '../../../Assets/Images/strategic.png';


// const solution = [
//   {
//     img : cyberImg,
//     title : "Cybersecurity Solutions",
//     desc : "We safeguard critical systems and data, detect threats early, and provide compliance-driven security frameworks to protect businesses from evolving digital risks.",
//     icon : artificial,
//     order : "order-1"
//   },
//   {
//     img : Cloude,
//     title : "Cloud Solutions Services",
//     desc : "We enable smooth cloud migration, optimize infrastructure, and deliver scalable, flexible solutions that drive innovation and sustainable long-term growth for modern enterprises.",
//     icon : cyberIcon,
//     order : "order-1"
//   },
//   {
//     img : strategic,
//     title : "Strategic IT Consulting",
//     desc : "We provide expert guidance, align technology with business goals, and design innovative strategies that ensure adaptability, resilience, and long-term success for organizations worldwide.",
//     icon : server,
//     order : "order-1"
//   },
//   {
//     img : aiService,
//     title : "AI & Analytics Services",
//     desc : "We harness data intelligence and AI to optimize operations, support smart decision-making, enhance performance, and uncover valuable opportunities for sustainable business growth.",
//     icon : strategicIcon,
//     order : "order-1"
//   }
// ];

// export default function Expertise() {
//   const [isVisible, setIsVisible] = useState(false);

//     const [scrollProgress, setScrollProgress] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       const element = document.getElementById("scroll-container");
//       if (!element) return;

//       const rect = element.getBoundingClientRect();
//       const elementTop = rect.top;
//       const elementHeight = rect.height;
//       const windowHeight = window.innerHeight;

//       // Calculate scroll progress (0 to 1)
//       const progress = Math.max(
//         0,
//         Math.min(
//           1,
//           (windowHeight - elementTop) / (windowHeight + elementHeight),
//         ),
//       );
//       setScrollProgress(progress);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => {
//     setIsVisible(true);
//   }, []);

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 py-20 px-6 relative overflow-hidden">
//       {/* Grid Pattern Background */}
//       <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:64px_64px]"></div>

//       {/* Decorative circle */}
//       <div className="absolute top-10 right-10 w-96 h-96 border border-slate-700/30 rounded-full"></div>

//       <div className="container mx-auto max-w-7xl relative z-10">
//         {/* Header Section */}
//         <div className="text-center space-y-8 mb-16">
//           {/* Badge */}
//           <div 
//             className={`inline-flex items-center gap-3 px-8 py-4 bg-blue-900/40 backdrop-blur-sm rounded-full border border-blue-500/30 transition-all duration-1000 
//               ${
//               isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
//             }
//             `}
//           >
//             <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
//             <span className="text-blue-100 font-medium">Our Expertise</span>
//             <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
//           </div>

//           {/* Heading */}
//           <div className="space-y-4">
//             <h2 
//               className={`text-5xl lg:text-6xl font-bold text-white leading-tight transition-all duration-1000 delay-200 ${
//                 isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
//               }`}
//             >
//               <span className="italic">Smart Solutions</span> for Modern Businesses
//             </h2>
//           </div>

//           {/* Description */}
//           <p 
//             className={`text-slate-300 text-lg max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-400 ${
//               isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
//             }`}
//           >
//             We provide end-to-end IT services designed to optimize operations, strengthen security, and accelerate digital transformation.
//           </p>
//         </div>

//         {/* Main Content Card */}
//         <div 
//         id="scroll-container"
//           className={`bg-gradient-to-br from-slate-50 to-slate-100 border-2 border-slate-800 rounded-[3rem] p-12 lg:p-16 shadow-2xl transition-all duration-1000 delay-600 ${
//             isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
//           }`
//         }
//         style={{ height: `${solution.length * 120}vh` }}
//         >
//           {solution.map((service, index)=>{
//             return(
//               <div key={index}   className='sticky w-full border-2 border-slate-800'
//                style={{
//                   top: "2rem",
//                   zIndex: index,
//                 }}
//               >
//              <div 
//              className=" grid lg:grid-cols-2 items-center  py-8 "
//              >
//             {/* Left - Illustration */}
//             <div className="relative">
//               <img src={service.img} alt={service.title} />

//                <div className="absolute -top-8 right-10">
//                   <div className="w-32 h-32 bg-gray-300  rounded-full flex items-center justify-center border-4 border-slate-800 shadow-xl">
//                     <img src={service.icon} alt=""  className='size-12 '/>
                    
//                   </div>
//                 </div>
//             </div>

//             {/* Right - Content */}
//             <div className="">
//               <div className="space-y-4 box-border">
//                 <h3 className="text-4xl lg:text-5xl font-bold text-slate-900">
//                   {service.title}
//                   <span>
//                      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="26" viewBox="0 0 80 26" fill="none" className='mt-2 mb-1'>
//                                         <path fill-rule="evenodd" clip-rule="evenodd" d="M15.873 2.7627C15.8731 4.45899 16.0664 6.13367 16.8838 7.50489C18.6463 10.461 21.4986 11.7483 25.6084 12.2842C27.1497 12.4851 28.8527 12.5787 30.7236 12.6172C32.6766 12.5771 34.8027 12.5965 37.0986 12.6172C38.5257 12.6044 40.0247 12.5918 41.5967 12.5918H80V13.4082H41.5967C40.0247 13.4082 38.5257 13.3956 37.0986 13.3828C34.8027 13.4035 32.6766 13.4219 30.7236 13.3818C28.8527 13.4203 27.1497 13.5149 25.6084 13.7158C21.4986 14.2517 18.6463 15.539 16.8838 18.4951C16.0664 19.8663 15.8731 21.541 15.873 23.2373V26C15.873 26 15.4996 26 15.127 26V23.2373C15.1269 21.541 14.9336 19.8663 14.1162 18.4951C12.3537 15.539 9.5014 14.2517 5.3916 13.7158C3.85001 13.5148 2.1467 13.4203 0.275391 13.3818C0.183999 13.3837 0.0921491 13.3831 0 13.3848V12.6133C0.0921563 12.6149 0.183992 12.6153 0.275391 12.6172C2.14669 12.5787 3.85001 12.4852 5.3916 12.2842C9.5014 11.7483 12.3537 10.461 14.1162 7.50489C14.9336 6.13367 15.1269 4.45899 15.127 2.7627V2.64338e-06C15.4996 -3.30422e-06 15.873 2.64338e-06 15.873 2.64338e-06V2.7627ZM15.5 6.10157C15.3308 6.72831 15.0906 7.33619 14.752 7.9043C12.8675 11.0647 9.85258 12.4249 5.80078 13C9.85258 13.5751 12.8675 14.9353 14.752 18.0957C15.0905 18.6636 15.3309 19.271 15.5 19.8975C15.6691 19.271 15.9095 18.6636 16.248 18.0957C18.1324 14.9355 21.1468 13.5751 25.1982 13C21.1468 12.4249 18.1324 11.0645 16.248 7.9043C15.9094 7.33619 15.6692 6.72831 15.5 6.10157Z" fill="currentColor"></path>
//                                     </svg>
//                   </span>
//                 </h3>
//               </div>

//               <p className="text-slate-600 text-lg leading-relaxed">
//                 {service.desc}
//               </p>

//               <div className="pt-4">
//                 <button className="group px-8 py-4 bg-slate-900 text-white rounded-xl font-medium hover:bg-slate-800 transition-all duration-300 hover:scale-105 hover:shadow-2xl flex items-center gap-3">
//                   Explore Now
//                   <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
//                 </button>
//               </div>
//             </div>
//           </div>
//           </div>
//             )
//           })}
          
//         </div>
//       </div>

//       <style>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0px); }
//           50% { transform: translateY(-10px); }
//         }

//         .animate-float {
//           animation: float 3s ease-in-out infinite;
//         }
//       `}</style>
//     </div>
//   );
// }


                                   